<script lang="ts">
  import SampleCard from "../SampleCard.svelte";
  import { Container, Row } from "sveltestrap";
  import Breadcrumb from "../../../Layout/Breadcrumb/Breadcrumb.svelte";
  import Bookmark from "../../../Layout/Breadcrumb/Bookmark.svelte";
  import { FooterDark, Footers, Home } from "../../../utils/Constant/Constant";
  import { onMount } from "svelte";
  import PreLodaer from "../../../Layout/PreLoader/PreLodaer.svelte";
  let ispreloader:boolean = false;
  onMount(() => {
		setTimeout(() => {
			ispreloader = true;
		}, 1000);
	});
</script>
{#if !ispreloader }
  <PreLodaer />
{/if}
<Container fluid>
  <div class="page-header">
    <Row>
      <Breadcrumb title={FooterDark} home={Home} parent={Footers} />
      <Bookmark />
    </Row>
  </div>
</Container>
<SampleCard />
